import React from 'react';

import ReferralProgramDetails from './Components/ReferralProgramDetails/index.jsx';
import Spinner from './Components/Spinner/index.jsx';

import AjaxService from './Services/Ajax/index.jsx';

import CurrentUser from '@scripts/utilities/current-user.js';


class ReferralProgram extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      referralId: undefined,
      growSurfInitialised: false
    };

    this.fetchComplete = this.fetchComplete.bind(this);
    this.initialiseGrowSurf = this.initialiseGrowSurf.bind(this);
  }

  componentDidMount() {
    AjaxService.fetch('theme:referral-program')
      .then(this.fetchComplete);
  }

  fetchComplete(result) {
    this.setState({ referralId: result });

    if (result) {
      window.addEventListener('grsfReady', this.initialiseGrowSurf);

      var script = document.createElement('script');
      script.src = 'https://app.growsurf.com/growsurf.js?v=2.0.0';
      script.setAttribute('grsf-campaign', window.SBM.growSurfCampaignId);
      script.async = true;
      document.head.appendChild(script);
    }
  }

  initialiseGrowSurf() {
    if (window.growsurf) {
      this.setState({ growSurfInitialised: true });
    } else {
      console.error('GrowSurf loaded event has been fired, but `growsurf` object not attached to window.');
    }
  }

  render() {
    if (this.state.referralId && this.state.growSurfInitialised) {
      return <ReferralProgramDetails referralId={CurrentUser.email} />;
    } else {
      return (
        <div className="cs-referral-program-page-content__section">
          <p className="text-muted text-center">Retrieving your referral program details...</p>
          <Spinner />
        </div>
      );
    }
  }
}


export default ReferralProgram;

